import { APIClient } from "api/api_helper";
import { VOLUNTEER_API } from "api/url_helper";
import {
  VolunteerTestRequest,
} from "modules/Volunteer/MasterVolunteer/helper/volunteer.types";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------ */

const api = new APIClient();

// ------------------------------------------------------------------
// Volunteer API
// ------------------------------------------------------------------

export const volunteerTestApiService = {
  getAllVolunteerTest: (payload: VolunteerTestRequest) => {
    return api.create(
      VOLUNTEER_API.VOLUNTEER_TEST + "SelectAll",
      payload
    );
  },
  getVolunteerTestCount: (payload: VolunteerTestRequest) => {
    return api.create(
      VOLUNTEER_API.VOLUNTEER_TEST + "Count",
      payload
    );
  },
  insertVolunteerTest: (payload: any) => {
    return api.create(
      VOLUNTEER_API.VOLUNTEER_TEST + "Insert",
      payload
    );
  },
  updateVolunteerTest: (payload: any) => {
    return api.create(
      VOLUNTEER_API.VOLUNTEER_TEST + "Update",
      payload
    );
  },
  deleteVolunteerTest: (payload: any) => {
    return api.create(
      VOLUNTEER_API.VOLUNTEER_TEST + "Delete",
      payload
    );
  },
};
